import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentEdiOrder', ediOrderTransformer.fetch(data));
  resolve(data);
};
const failed = (error, reject) => reject(error);

export default (id, ediOrder) => (
  new Promise((resolve, reject) => {
    let url = `edi_orders/${id}/process`;

    if (localStorage.getItem('is_admin')) {
      url = `edi_orders/${id}/process?is_admin=true`;
    }

    Vue.$http
      .post(url, ediOrder)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/process.js